import React from "react";
import $api from "shared/hooks/api";
import { setAuthToken } from "shared/utils/setAuthToken";
import { AuthContext } from "app/context/useAuth";

function getAccessToken() {
  const accessToken = localStorage.getItem("accessToken");
  return accessToken ? accessToken : "";
}

export const AuthProvider = ({ children }: { children: JSX.Element }) => {
  const initialToken = getAccessToken();
  const [token, setToken] = React.useState(initialToken);

  const handleLogin = async () => {
    const token: string = await getAccessToken();

    setToken(token);
    //const origin = location.state?.from?.pathname || "/";
    //navigate(origin);
  };

  const handleLogout = async () => {
    await $api.get("/auth/logout");
    setAuthToken("", "");
    localStorage.removeItem("user");
    localStorage.removeItem("ability");
    setToken("");
  };

  const value = {
    token,
    onLogin: handleLogin,
    onLogout: handleLogout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
